import { Phone, Instagram, MessageCircle } from "lucide-react";
import { BUSINESS, whatsappLink } from "../../data/site";

const MobileActionBar = () => (
  <div
    data-testid="mobile-action-bar"
    className="fixed inset-x-0 bottom-0 z-[70] grid grid-cols-3 border-t border-ink/10 bg-bone/95 backdrop-blur-md md:hidden"
  >
    <a
      href={`tel:+${BUSINESS.phone}`}
      data-testid="mobile-call-btn"
      className="flex flex-col items-center justify-center gap-1 py-3 text-ink transition-colors active:bg-cashmere"
      aria-label="Call Arjun"
    >
      <Phone className="h-5 w-5 text-henna" />
      <span className="text-[10px] uppercase tracking-[0.18em]">Call</span>
    </a>

    <a
      href={BUSINESS.instagram}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-insta-btn"
      className="flex flex-col items-center justify-center gap-1 border-x border-ink/10 py-3 text-ink transition-colors active:bg-cashmere"
      aria-label="Instagram"
    >
      <Instagram className="h-5 w-5 text-henna" />
      <span className="text-[10px] uppercase tracking-[0.18em]">Instagram</span>
    </a>

    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-whatsapp-btn"
      className="flex flex-col items-center justify-center gap-1 bg-[#25D366] py-3 text-white transition-opacity active:opacity-90"
      aria-label="WhatsApp"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="text-[10px] uppercase tracking-[0.18em]">WhatsApp</span>
    </a>
  </div>
);

export default MobileActionBar;
